import httpClient from '@/http-client'
export const studentList = data => {
  return httpClient
    .get('/api/report/student-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentListExcel = data => {
  return httpClient
    .post('/api/report/student-lists/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const studentListForMoeys = data => {
  return httpClient
    .get('/api/report/student-list-for-moeys', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentExamListForMoeys = data => {
  return httpClient
    .post('/api/report/student-exam-list-for-meoys', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const infoInquiry = data => {
  return httpClient
    .get('/api/report/info-inquiries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentTransfer = data => {
  return httpClient
    .get('/api/report/student-transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentEnrollment = data => {
  return httpClient
    .get('/api/report/student-enrollments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const transportation = data => {
  return httpClient
    .get('/api/report/transportations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const classTeaching = data => {
  return httpClient
    .get('/api/report/class-teaching', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const inactiveStudent = data => {
  return httpClient
    .get('/api/report/inactive-students', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentExchange = data => {
  return httpClient
    .get('/api/report/student-exchanges', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const foundationYear = data => {
  return httpClient
    .get('/api/report/foundation-years', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const confirmation = data => {
  return httpClient
    .get('/api/report/confirmations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const transcript = data => {
  return httpClient
    .get('/api/report/transcripts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const provisional = data => {
  return httpClient
    .get('/api/report/provisionals', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const finalResult = data => {
  return httpClient
    .get('/api/report/final-results', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const reportCard = data => {
  return httpClient
    .get('/api/report/report-cards', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoringCycle = Options => {
  return httpClient
    .get('/api/report/scoring/cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getScoringCycleValue = Options => {
  return httpClient
    .get('/api/report/scoring/cycle-values', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const classAttendance = data => {
  return httpClient
    .get('/api/report/class-attendances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const classAttendanceExcel = data => {
  return httpClient
    .post('/api/report/class-attendances/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const header = (Options = {}) => {
  return httpClient
    .get('/api/report/class-attendances/get-header', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentClassAttendanceExcel = data => {
  return httpClient
    .post('/api/report/student-class-attendances/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const attendanceByStudentExcel = data => {
  return httpClient
    .post('/api/report/attendance-by-students/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const studentFollowUp = data => {
  return httpClient
    .get('/api/report/student-follow-ups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const scoringReport = data => {
  return httpClient
    .get('/api/report/scoring-reports', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const scoreList = data => {
  return httpClient
    .get('/api/report/score-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentSemesterExamList = data => {
  return httpClient
    .get('/api/report/student-semester-exam-ists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const thesisRegistration = data => {
  return httpClient
    .get('/api/report/thesis-registrations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const formViewModel = Options => {
  return httpClient
    .get('/api/report/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const academicReport = data => {
  return httpClient
    .get('/api/report/academic-reports', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const finalResultExportExcel = data => {
  return httpClient
    .post('/api/report/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const studentSemesterExamListExcel = data => {
  return httpClient
    .post('/api/report/student-semester-exam-lists/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const reExamExportExcel = data => {
  return httpClient
    .post('/api/report/re-exam-export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const academicResult = data => {
  return httpClient
    .get('/api/report/academic-results', {
      params: data
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  studentList,
  studentListExcel,
  studentListForMoeys,
  infoInquiry,
  studentTransfer,
  studentEnrollment,
  transportation,
  classTeaching,
  inactiveStudent,
  studentExchange,
  foundationYear,
  confirmation,
  transcript,
  provisional,
  finalResult,
  scoreList,
  studentExamListForMoeys,
  classAttendance,
  classAttendanceExcel,
  studentClassAttendanceExcel,
  attendanceByStudentExcel,
  header,
  studentFollowUp,
  scoringReport,
  studentSemesterExamList,
  thesisRegistration,
  academicReport,
  formViewModel,
  finalResultExportExcel,
  getScoringCycle,
  getScoringCycleValue,
  studentSemesterExamListExcel,
  reExamExportExcel,
  academicResult
}
